import React from "react";

import * as S from "./styled";

export default function FairHousingBanner() {
  const handleAnalyticsBannerClick = () => {
    window.dataLayer.push({
      event: "custom_event",
      event_category: "homepage",
      event_action: "fair_housing_notice",
      event_label: "click"
    });
  };

  return (
    <S.FairHousingBannerContainer>
      <S.FairHousingBannerCopy>
        Fair Housing in NYC:{" "}
        <S.FairHousingBannerLink
          href="https://dos.ny.gov/system/files/documents/2021/08/fairhousingnotice.pdf"
          onClick={handleAnalyticsBannerClick}
          target="_blank"
        >
          Understand your rights.
        </S.FairHousingBannerLink>
      </S.FairHousingBannerCopy>
    </S.FairHousingBannerContainer>
  );
}
